exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bubble-arrow[data-v-52c9f6d6] {\n  position: absolute;\n  float: left;\n  left: -11px;\n  top: 0px;\n}\n.bubble-arrow.alt[data-v-52c9f6d6] {\n  top: 0;\n  left: auto;\n  right: 4px;\n  float: right;\n}\n.bubble-arrow[data-v-52c9f6d6]:after {\n  content: \"\";\n  position: absolute;\n  border-top: 15px solid rgb(237, 242, 247);\n  border-left: 15px solid transparent;\n  border-radius: 4px 0 0 0px;\n  width: 0;\n  height: 0;\n}\n.bubble-arrow.alt[data-v-52c9f6d6]:after {\n  border-top: 15px solid rgb(226, 232, 240);\n  transform: scaleX(-1);\n}\n", ""]);

// exports
